import { getStateWithOnlyOneLevel } from '../../utils/StateSelectorHelper';

function getResourcesState(state) {
  return getStateWithOnlyOneLevel(state, 'resources');
}

export const getPosts = (state) => getResourcesState(state).get('posts');

export const getCategories = (state) =>
  getResourcesState(state).get('categories');

export const getIsLoading = (state) =>
  getResourcesState(state).get('isLoading');

export const getTotalPosts = (state) =>
  getResourcesState(state).get('totalPosts');

export const getLoadMoreState = (state) =>
  getResourcesState(state).get('loadMoreState');

export const getFeaturedBlog = (state) =>
  getResourcesState(state).get('featuredBlog');
